import { Html, Image } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function BlogHeader(props) {
    var _props_blockImage, _props_blockImage1;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative overflow-hidden px-6 md:px-14 mb-10", {})
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto max-w-7xl relative md:pt-[5.5rem] lg:pt-20", {})
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative z-10 md:flex gap-x-10 lg:gap-x-12", {})
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("md:w-3/5", {})
    }, props.breadcrumb && /*#__PURE__*/ React.createElement("div", {
        className: "border-t border-t-gray-25"
    }, /*#__PURE__*/ React.createElement(ArrowLink, {
        target: props.breadcrumb.target,
        text: props.breadcrumb.label,
        reverse: true,
        className: "block text-gray-600 pt-4 text-sm pb-8 md:max-w-xl lg:max-w-2xl xl:max-w-4xl"
    })), props.readTime && /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-200 text-sm pb-1.5 block md:max-w-xl lg:max-w-2xl xl:max-w-4xl"
    }, "Read time: ", props.readTime), /*#__PURE__*/ React.createElement("h1", {
        className: "text-[2rem] leading-tight md:text-4xl lg:text-5xl xl:text-6xl lg:leading-tight font-heading font-semibold"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-block pb-5 lg:pr-[27px]"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.heading,
        classNames: {
            em: "text-orange-500 not-italic"
        }
    }))), props.summary && /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-100 lg:text-xl pb-3 lg:pb-7 inline-block md:max-w-xl lg:max-w-2xl xl:max-w-4xl"
    }, props.summary), props.authors && /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-600 lg:text-xl mb-1 block md:max-w-xl lg:max-w-2xl xl:max-w-4xl"
    }, "by ", props.authors), props.date && /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-100 lg:text-xl mb-7 block md:max-w-xl lg:max-w-2xl xl:max-w-4xl"
    }, props.date), props.terms ? /*#__PURE__*/ React.createElement("div", {
        className: "mb-8 md:mb-0"
    }, props.terms.map(function(term, key) {
        /*#__PURE__*/ return React.createElement("span", {
            key: key,
            className: "text-xs text-center mr-2 text-gray-100 bg-white font-heading mb-2 px-3.5 py-1.5 border border-gray-600 rounded-full inline-block"
        }, term === null || term === void 0 ? void 0 : term.name);
    })) : null), /*#__PURE__*/ React.createElement("div", {
        className: "md:w-2/5 lg:pb-8"
    }, ((_props_blockImage = props.blockImage) === null || _props_blockImage === void 0 ? void 0 : _props_blockImage.source) && /*#__PURE__*/ React.createElement("div", {
        className: "aspect-w-1 aspect-h-1 bg-white"
    }, /*#__PURE__*/ React.createElement(Image, {
        className: "!absolute rounded-2xl overflow-hidden border border-gray-900 block w-full max-w-full object-cover h-full",
        source: props.blockImage.source,
        alt: (_props_blockImage1 = props.blockImage) === null || _props_blockImage1 === void 0 ? void 0 : _props_blockImage1.alt,
        priority: true
    })))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1228px",
        height: "1473px",
        viewBox: "0 0 1228 1473",
        version: "1.1",
        className: "knime-hidden lg:block absolute -top-28 xl:-top-16 -right-[640px] xl:-right-[450px]"
    }, /*#__PURE__*/ React.createElement("title", null, "Stacked Triangles"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Blog-Detail-Page",
        transform: "translate(-624.000000, 2.000000)",
        fill: "#A8A7A7",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pattern/Hero",
        transform: "translate(720.000000, 296.000000) rotate(-180.000000) translate(-720.000000, -296.000000) translate(0.000000, 0.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Stacked-Triangles",
        transform: "translate(-412.000000, -778.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M-1.74389704e-13,1273.60314 L248.942359,0 L1227.44747,852.395294 L1213.3263,857.243453 L-1.74389704e-13,1273.60314 L-1.74389704e-13,1273.60314 Z M260.13604,32.6156959 L22.6494094,1247.60345 L1193.60689,845.782087 L260.13604,32.6156959 L260.13604,32.6156959 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M112.432971,1323.67126 L206.394747,289.779289 L1054.78686,888.096614 L112.432971,1323.67126 L112.432971,1323.67126 Z M218.091848,315.08615 L128.502168,1300.88514 L1027.02056,885.573079 L218.091848,315.08615 L218.091848,315.08615 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M225.014845,1373.54829 L163.937372,579.776765 L881.887666,923.762453 L225.014845,1373.54829 L225.014845,1373.54829 Z M175.959097,597.335345 L234.208817,1354.35261 L860.67169,925.396758 L175.959097,597.335345 L175.959097,597.335345 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M337.648122,1422.87971 L121.923072,870.093279 L708.491763,959.649273 L337.648122,1422.87971 L337.648122,1422.87971 Z M133.381594,879.265501 L339.863504,1408.37127 L694.819257,964.988561 L133.381594,879.265501 L133.381594,879.265501 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M449.265341,1471.10344 L81.3849482,1160.08796 L84.6736579,1158.90679 L534.637417,996.982103 L449.265341,1471.10344 L449.265341,1471.10344 Z M89.3307077,1161.52308 L446.531734,1463.50266 L529.425265,1003.14804 L89.3307077,1161.52308 L89.3307077,1161.52308 L89.3307077,1161.52308 Z",
        id: "Shape"
    }))))))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "390px",
        height: "810px",
        viewBox: "0 0 390 810",
        version: "1.1",
        className: "lg:hidden absolute -bottom-4 md:-bottom-28 -right-6 md:-right-16 max-w-full"
    }, /*#__PURE__*/ React.createElement("title", null, "Panel BG"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "390",
        height: "810"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Mobile",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Panel-BG",
        transform: "translate(195.000000, 405.000000) scale(1, -1) translate(-195.000000, -405.000000) "
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        mask: "url(#mask-2)",
        fill: "#A8A7A7",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(786.000000, 388.500000) scale(1, -1) rotate(-270.000000) translate(-786.000000, -388.500000) translate(130.000000, -398.000000)",
        id: "Shape"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,1361.81977 L266.090716,0 L1312,911.436794 L1296.9061,916.620761 L0,1361.81977 L0,1361.81977 Z M278.055473,34.8748351 L24.2096105,1334.0192 L1275.82832,904.36552 L278.055473,34.8748351 L278.055473,34.8748351 Z",
        transform: "translate(656.000000, 680.909886) scale(-1, 1) translate(-656.000000, -680.909886) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    }))))))));
}
